import DriveshaftToleranceWidget from "./Driveshaft";

export default function DriveshaftToleranceWidgetPage() {
  return <DriveshaftToleranceWidget />;
}
